import { render, staticRenderFns } from "./LoanRequest.vue?vue&type=template&id=1881bcc0&"
import script from "./LoanRequest.vue?vue&type=script&lang=js&"
export * from "./LoanRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports